/*
 * a Collection of regions, each showing the cancel action labels for a single language
 */

define(["marionette", "./template/cancelActionLabelDisplayTemplate.html"], function (
  Marionette,
  CancelActionLabelDisplayTemplate,
) {
  var CancelActionLabelDisplayView = {};

  CancelActionLabelDisplayView.label = Marionette.ItemView.extend({
    template: CancelActionLabelDisplayTemplate,
    textboxes: {
      ".cancel-action-label": {
        enableSelector: ".cancel-action-label",
        modelAttribute: "labelText",
        placeholder: "admin.cancelAction.label",
        textArea: false,
      },
    },
  });

  CancelActionLabelDisplayView.cancelActionLabels = Marionette.CollectionView.extend({
    itemView: CancelActionLabelDisplayView.label,
  });

  return CancelActionLabelDisplayView;
});
